module.exports = __webpack_public_path__ + "static/media/union.a3f1d983.svg";